module.exports = __webpack_public_path__ + "img/tonghaoyue.e3212e8e.jpg";